/**
 * Owner: Masa Bayu
 * File: hero-banners.ts
 * Date:Time: 2026-09-17 23:12
 * Description: H1 hero banner slides — Vite-bundled PNG assets (Banner 1–7, qx1–qx7 2048×768).
 */

import banner1 from '../assets/home/hero/banner-1.png';
import banner2 from '../assets/home/hero/banner-2.png';
import banner3 from '../assets/home/hero/banner-3.png';
import banner4 from '../assets/home/hero/banner-4.png';
import banner5 from '../assets/home/hero/banner-5.png';
import banner6 from '../assets/home/hero/banner-6.png';
import banner7 from '../assets/home/hero/banner-7.png';

export type HeroBannerSlide = {
  readonly id: string;
  readonly src: string;
  readonly alt: string;
};

/** Bundled via Vite so URLs resolve in dev + production (not bare /public paths). */
export const HERO_BANNER_SLIDES: readonly HeroBannerSlide[] = Object.freeze([
  { id: 'banner-1', src: banner1, alt: 'QXRead featured banner 1' },
  { id: 'banner-2', src: banner2, alt: 'QXRead featured banner 2' },
  { id: 'banner-3', src: banner3, alt: 'QXRead featured banner 3' },
  { id: 'banner-4', src: banner4, alt: 'QXRead featured banner 4' },
  { id: 'banner-5', src: banner5, alt: 'QXRead featured banner 5' },
  { id: 'banner-6', src: banner6, alt: 'QXRead featured banner 6' },
  { id: 'banner-7', src: banner7, alt: 'QXRead featured banner 7' },
]);
